<template>
  <div class="stocks-catalog">
    <div class="stocks-catalog__header">
      <DefBreadCrumbs />
      <DefTitle :result="1" :center="screenWidth >= 992">
        <h1>{{ stock.name }}</h1>
      </DefTitle>
      <p class="stocks-catalog__time">{{ stock.activePeriod }}</p>
      <StocksBanner :result="stock" :messages="messages" />

      <DefContent v-html="stock.detailText" />
    </div>

    <div v-if="stock.restrictions" class="stocks-restriction" v-html="stock.restrictions"></div>

    <DefTitle v-if="+pagination.elementsCount > 0" :result="2" :center="screenWidth >= 992">
      <h2>
        {{ messages.products }}
        <span class="stocks-catalog__count">{{ pagination.elementsCount }}</span>
      </h2>
    </DefTitle>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import useScreenWidth from '@use/useScreenWidth';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import StocksBanner from '@components/Stocks/StocksBanner.vue';
import DefContent from '@components/Def/DefContent/DefContent.vue';

export default {
  name: 'StocksCatalog',
  components: { DefContent, StocksBanner, DefTitle, DefBreadCrumbs },
  computed: {
    ...mapState({
      stock: ({ results }) => results?.action,
      messages: ({ results }) => results?.messages,
      pagination: ({ catalog }) => catalog?.data?.catalogSectionList?.pagination,
      screenWidth: useScreenWidth,
    }),
  },
  mounted() {
    /** костылек для отключения хлебных крошек каталога товаров. @todo Dima Pavliuk you may clear that shit and make it norm */
    // this.$nextTick(() => {
    //   const catalogBreadCrumbs = document.querySelector('.catalog .container .def-bread-crumbs');
    //   catalogBreadCrumbs.remove();
    // });
  },
};
</script>

<style lang="scss" scoped>
.stocks-catalog {
  &__header {
    @include point-lg {
      text-align: center;
    }
  }
  &__time {
    font-weight: 600;
    font-size: rem(14);
    line-height: 115%;
    color: var(--color-dark-grey);
    margin-bottom: 24px;
    @include point-md {
      margin-bottom: 32px;
    }
  }
  &__count {
    color: var(--color-grey);
  }
  :deep(.def-content) {
    margin-bottom: 40px;
    @include point-lg {
      margin-bottom: 48px;
    }
    ul {
      margin-top: 0;
      @include point-lg {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
  :deep(.def-title-2) {
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 24px;
    }
  }
}
.stocks-restriction {
  :deep {
    padding: 24px 16px;
    background-color: #f6f6f6;
    margin-bottom: 40px;
    color: var(--color-dark-grey);
    @include point-md {
      padding: 32px 20px;
      margin-bottom: 48px;
    }
    @include point-lg {
      padding: 32px 48px;
      margin-bottom: 64px;
    }
    &__title {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: rem(16);
      letter-spacing: 0.04em;
      text-transform: uppercase;
      margin-bottom: 16px;
    }
    &__icon {
      display: inline-block;
      fill: currentColor;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    p {
      @include point-md {
        font-size: rem(14);
      }
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
}
//:global(.catalog .container .def-bread-crumbs) {
//  display: none;
//}
</style>
